(() => {
  'use strict';

  const root =
    document.querySelector('[data-pnmatch-root]');

  if (!root) return;


  const escapeHTML = value =>
    String(value ?? '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');


  const shell =
    document.createElement('div');

  shell.className = 'pnintel';

  shell.innerHTML = `
    <div class="pnintel-grid">

      <section class="pnintel-card">

        <header class="pnintel-head">

          <div>
            <small>MY MATCHES</small>
            <h3>Your ranked college matches</h3>
          </div>

          <button
            type="button"
            class="pnintel-button"
            data-pnintel-generate
          >
            Generate matches
          </button>

        </header>

        <div data-pnintel-results>
          <div class="pnintel-state">
            Complete your Match Profile and generate your personalized results.
          </div>
        </div>

      </section>


      <section class="pnintel-card">

        <header class="pnintel-head">

          <div>
            <small>EXAMS + RANK</small>
            <h3>Admission intelligence</h3>
          </div>

        </header>


        <form
          class="pnintel-exam-form"
          data-pnintel-exam-form
        >

          <select name="exam_id" required>
            <option value="">Loading entrance exams…</option>
          </select>

          <div class="pnintel-row">

            <input
              type="number"
              name="attempt_year"
              min="2000"
              max="2100"
              placeholder="Year"
              required
            >

            <input
              type="text"
              name="category"
              placeholder="Category"
            >

          </div>

          <div class="pnintel-row">

            <input
              type="number"
              step="0.01"
              name="score"
              placeholder="Score"
            >

            <input
              type="number"
              step="0.0001"
              min="0"
              max="100"
              name="percentile"
              placeholder="Percentile"
            >

          </div>

          <input
            type="number"
            min="1"
            name="official_rank"
            placeholder="Official rank, if available"
          >

          <input
            type="text"
            name="domicile_state"
            placeholder="Domicile state"
          >

          <button
            type="submit"
            class="pnintel-button"
          >
            Save + predict rank
          </button>

        </form>

        <div
          class="pnintel-exam-list"
          data-pnintel-exams
        ></div>

      </section>

    </div>
  `;


  root.insertAdjacentElement(
    'afterend',
    shell
  );


  const resultsNode =
    shell.querySelector('[data-pnintel-results]');

  const generateButton =
    shell.querySelector('[data-pnintel-generate]');

  const examForm =
    shell.querySelector('[data-pnintel-exam-form]');

  const examsNode =
    shell.querySelector('[data-pnintel-exams]');


  let preferences = null;


  async function rpc(name, body = {}) {

    return window.PeerNestDB.request(
      `rpc/${name}`,
      '',
      {
        method:'POST',
        body
      }
    );

  }


  function setMatchCount(count) {

    const node =
      document.querySelector(
        '[data-pndash-match-count]'
      );

    if (node) {
      node.textContent = String(count);
    }

  }


  async function loadMatches() {

    const rows =
      await rpc(
        'get_my_college_matches',
        {
          p_limit:12
        }
      );


    const matches =
      Array.isArray(rows)
        ? rows
        : [];


    setMatchCount(
      matches.length
    );


    if (!matches.length) {

      resultsNode.innerHTML = `
        <div class="pnintel-state">
          No generated matches yet.
        </div>
      `;

      return;

    }


    resultsNode.innerHTML = `
      <div class="pnintel-results">

        ${matches.map(row => `
          <article
            class="pnintel-match"
            data-pnintel-card="${escapeHTML(row.college_id)}"
          >

            <div class="pnintel-score">
              ${Math.round(Number(row.match_score || 0))}%
            </div>

            <div>

              <h4>
                ${escapeHTML(row.college_name)}
              </h4>

              <p>
                ${escapeHTML(
                  [row.city,row.state]
                    .filter(Boolean)
                    .join(', ')
                )}
                ·
                ${Math.round(
                  Number(row.data_confidence || 0)
                )}% data confidence
              </p>

              <div class="pnintel-reasons">

                ${
                  Array.isArray(row.reasons)
                    ? row.reasons
                        .slice(0,3)
                        .map(reason =>
                          `<span>${escapeHTML(reason)}</span>`
                        )
                        .join('')
                    : ''
                }

              </div>

              <div
                class="pnintel-admission"
                data-pnintel-admission
                hidden
              ></div>

            </div>

            <button
              type="button"
              data-pnintel-admission-button
              data-college="${escapeHTML(row.college_id)}"
            >
              Check admission
            </button>

          </article>
        `).join('')}

      </div>
    `;


    resultsNode
      .querySelectorAll(
        '[data-pnintel-admission-button]'
      )
      .forEach(button => {

        button.addEventListener(
          'click',
          async () => {

            const card =
              button.closest('.pnintel-match');

            const output =
              card.querySelector(
                '[data-pnintel-admission]'
              );

            output.hidden = false;

            output.textContent =
              'Checking your exam profile against recent cutoffs…';

            button.disabled = true;


            try {

              const data =
                await rpc(
                  'get_my_admission_outlook',
                  {
                    p_college_id:
                      button.dataset.college,

                    p_course_id:
                      preferences?.preferred_course_id || null
                  }
                );


              const rows =
                Array.isArray(data)
                  ? data
                  : [];


              if (!rows.length) {

                output.textContent =
                  'No matching cutoff data is available yet.';

              }
              else {

                output.innerHTML =
                  rows.map(item => `
                    <strong>
                      ${escapeHTML(item.exam_name)}
                    </strong>
                    —
                    ${escapeHTML(
                      String(
                        item.outlook ||
                        'insufficient_data'
                      ).replaceAll('_',' ')
                    )}
                  `).join('<br>');

              }

            }
            catch (error) {

              output.textContent =
                error?.message ||
                'Admission outlook could not be loaded.';

            }
            finally {

              button.disabled = false;

            }

          }
        );

      });

  }


  async function loadExams() {

    const rows =
      await window.PeerNestDB.request(
        'entrance_exams',
        'select=*&order=name.asc'
      );


    const select =
      examForm.elements.exam_id;


    select.innerHTML = `
      <option value="">
        Choose entrance exam
      </option>

      ${
        (Array.isArray(rows) ? rows : [])
          .map(exam => `
            <option value="${escapeHTML(exam.id)}">
              ${escapeHTML(exam.name)}
            </option>
          `)
          .join('')
      }
    `;

  }


  async function loadProfiles() {

    const rows =
      await rpc(
        'get_my_exam_profiles'
      );


    const profiles =
      Array.isArray(rows)
        ? rows
        : [];


    if (!profiles.length) {

      examsNode.innerHTML = `
        <div class="pnintel-state">
          Add an entrance exam to start Rank Predictor.
        </div>
      `;

      return;

    }


    examsNode.innerHTML =
      profiles.map(profile => {

        let rank =
          'Prediction not generated';


        if (profile.official_rank) {

          rank =
            `Official rank: ${Number(
              profile.official_rank
            ).toLocaleString('en-IN')}`;

        }
        else if (
          profile.predicted_rank_min &&
          profile.predicted_rank_max
        ) {

          rank =
            `Predicted: ${Number(
              profile.predicted_rank_min
            ).toLocaleString('en-IN')}–${Number(
              profile.predicted_rank_max
            ).toLocaleString('en-IN')}`;

        }
        else if (
          profile.prediction_confidence ===
          'insufficient_data'
        ) {

          rank =
            'Verified historical rank data is not available yet.';

        }


        return `
          <article class="pnintel-exam">

            <strong>
              ${escapeHTML(profile.exam_name)}
              ·
              ${escapeHTML(profile.attempt_year)}
            </strong>

            <small>
              ${escapeHTML(rank)}
            </small>

          </article>
        `;

      }).join('');

  }


  generateButton.addEventListener(
    'click',
    async () => {

      generateButton.disabled = true;
      generateButton.textContent = 'Matching…';


      try {

        await rpc(
          'generate_my_college_matches',
          {
            p_limit:50
          }
        );

        await loadMatches();

      }
      catch (error) {

        resultsNode.innerHTML = `
          <div class="pnintel-state">
            ${escapeHTML(
              error?.message ||
              'Could not generate matches.'
            )}
          </div>
        `;

      }
      finally {

        generateButton.disabled = false;
        generateButton.textContent =
          'Generate matches';

      }

    }
  );


  examForm.addEventListener(
    'submit',
    async event => {

      event.preventDefault();

      const submit =
        examForm.querySelector(
          'button[type="submit"]'
        );

      const form =
        new FormData(examForm);


      submit.disabled = true;
      submit.textContent = 'Saving…';


      try {

        const saved =
          await rpc(
            'save_my_exam_profile',
            {
              p_profile:{
                exam_id:
                  form.get('exam_id'),

                attempt_year:
                  form.get('attempt_year'),

                score:
                  form.get('score') || null,

                percentile:
                  form.get('percentile') || null,

                official_rank:
                  form.get('official_rank') || null,

                category:
                  form.get('category') || null,

                domicile_state:
                  form.get('domicile_state') || null
              }
            }
          );


        if (saved?.id) {

          await rpc(
            'predict_my_exam_rank',
            {
              p_profile_id:
                saved.id
            }
          );

        }


        examForm.reset();

        examForm.elements.attempt_year.value =
          String(
            new Date().getFullYear()
          );


        await loadProfiles();

      }
      catch (error) {

        window.alert(
          error?.message ||
          'Could not save exam profile.'
        );

      }
      finally {

        submit.disabled = false;
        submit.textContent =
          'Save + predict rank';

      }

    }
  );


  async function init() {

    examForm.elements.attempt_year.value =
      String(
        new Date().getFullYear()
      );


    try {

      preferences =
        await rpc(
          'get_my_match_preferences'
        );

    }
    catch (_) {}


    await Promise.allSettled([
      loadMatches(),
      loadExams(),
      loadProfiles()
    ]);

  }


  if (window.PeerNestDB) {

    init();

  }
  else {

    document.addEventListener(
      'peernest:supabase-ready',
      init,
      {
        once:true
      }
    );

  }

})();
